<template>
    <div>
        <common-icon v-if="isActivePackage" class="package-info__icon" name="theme-selected" size="extra-huge"></common-icon>
        <h3 class="package-info__title">{{ packageOption.title }}</h3>
        <div class="package-info__price">
            <h2 class="package-info__price-title">{{ getSubscriptionPrice(packageOption.price) }}</h2>
            <span class="package-info__price-currency">{{ currency }}</span>
        </div>
        <div class="package-info_list">
            <div v-for="(benefit, index) in packageOption.benefits" :key="index" class="package-info__list-item">
                <common-icon name="check-circle" size="small"></common-icon>
                {{ benefit }}
            </div>
        </div>
        <div :class="getButtonClass(packageOption.class)">
            <common-button
                type="secondary"
                size="small"
                :isFluid="true"
                :isDisabled="isDisabled"
                :label="$t(packageLabel)"
                @click="choosePackage(packageOption.class)"
            ></common-button>
        </div>
    </div>
</template>

<script>
    import Store from '@/store'
    import CurrencyEnum from 'enums/currency.enum'

    export default {
        props: {
            packageOption: { type: Object, default: null },
            isSubsciptionYearly: { type: Boolean, default: false },
            isActivePackage: { type: Boolean, default: false },
            packageLabel: { type: String, default: 'forms.company.create_company.start_for_free' },
            isDisabled: { type: Boolean, default: false },
            regularYearly: { type: String, default: process.env.VUE_APP_PACKAGE_REGULAR_YEARLY },
            regularMonthly: { type: String, default: process.env.VUE_APP_PACKAGE_REGULAR },
            subdomainYearly: { type: String, default: process.env.VUE_APP_PACKAGE_SUBDOMAIN_YEARLY },
            subdomainMonthly: { type: String, default: process.env.VUE_APP_PACKAGE_SUBDOMAIN },
            currency: { type: String, default: CurrencyEnum.RSD },
        },

        data() {
            return {
                getCountryByGeolocation: Store.getters['data/getCountryByGeolocation'],
            }
        },

        methods: {
            getButtonClass(packageClass) {
                return {
                    ['package-info__button']: true,
                    [`package-info__button-${packageClass}`]: true,
                }
            },

            choosePackage(optionPackage) {
                this.emitEvent({ name: 'package-chosen', payload: optionPackage })
            },

            getSubscriptionPrice() {
                const yearlyPrice = this.packageOption?.key === 'basic' ? this.regularYearly : this.subdomainYearly
                const monthlyPrice = this.packageOption?.key === 'basic' ? this.regularMonthly : this.subdomainMonthly

                return this.isSubsciptionYearly ? yearlyPrice : monthlyPrice
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/package/_package-info.scss';
</style>
